export default "/react/logoClickFraud-c22e6595.png";